import { SET_PLANS_REQUESTING, SET_PLANS } from '../actionTypes.constants'

const defaultState = {
  loading: true,
  plans: [],
}

const smartySharedData = (state = defaultState, action) => {
  switch (action.type) {
    case SET_PLANS_REQUESTING: {
      return {
        ...state,
        loading: true,
      }
    }

    case SET_PLANS: {
      return {
        ...state,
        loading: false,
        plans: action.plans,
      }
    }

    default:
      return state
  }
}

export default smartySharedData
